import React, { useState } from 'react';
import { Link, Outlet } from 'react-router-dom';
import { FaYoutube, FaFacebookF, FaPhoneAlt, FaLinkedin, FaInstagramSquare } from 'react-icons/fa';
import logo from '../assets/SKYFORD_AVIATION_LOGO.png';
import Menu from './Menu';
import Footer from './Footer';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  return (
    <div className="relative">
      {/* Top Section */}
      <div className="bg-white py-4">
        <div className="max-w-7xl mx-auto px-4 flex justify-center sm:justify-between items-center">
          {/* Social Media */}
          <div className="hidden sm:flex items-center gap-4">
            <a href="https://www.facebook.com/skyfordaviation/" className="text-red-600 transition-colors">
              <FaFacebookF size={18} />
            </a>
            <a href="https://www.instagram.com/skyford_aviation?igsh=N2phd2lrbHN3N2E5" className="text-red-600 transition-colors">
              <FaInstagramSquare size={18} />
            </a>
            <a href="https://www.linkedin.com/company/skyford-aviation/" className="text-red-600 transition-colors">
              <FaLinkedin size={18} />
            </a>
            <a href="http://www.youtube.com/@skyfordaviation" className="text-red-600 transition-colors">
              <FaYoutube size={18} />
            </a>
          </div>

          {/* Logo */}
          <Link to='/'><img src={logo} alt="Skyford Aviation" className="h-8 sm:h-10" /></Link>

          {/* Phone */}
          <div className="hidden sm:flex items-center gap-2 text-red-600">
            <FaPhoneAlt size={18} className="text-red-600" />
            <span>
              <a href="tel:+919895332211" className="hover:underline">
                +91 98953 32211
              </a>
            </span>
          </div>
        </div>
      </div>

      {/* Navigation Section */}
      <div className="bg-[#F01923] shadow-md  z-50 md:py-3 uppercase">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex justify-between relative items-center py-6 md:py-0">
            {/* Menu Toggle Button */}
            <button
              onClick={toggleMenu}
              className={`absolute right-5 top-[25%] md:hidden text-white text-2xl focus:outline-none z-50`}
            >
              <div className="relative w-6 h-6">
                <span
                  className={`absolute w-full h-0.5 bg-current transform transition-all duration-300 ${
                    menuOpen ? 'rotate-45 top-3' : 'top-1'
                  }`}
                ></span>
                <span
                  className={`absolute w-full h-0.5 bg-current top-3 transition-all duration-300 ${
                    menuOpen ? 'opacity-0' : 'opacity-100'
                  }`}
                ></span>
                <span
                  className={`absolute w-full h-0.5 bg-current transform transition-all duration-300 ${
                    menuOpen ? '-rotate-45 top-3' : 'top-5'
                  }`}
                ></span>
              </div>
            </button>

            {/* Menu */}
            <Menu menuOpen={menuOpen} toggleMenu={toggleMenu} />
          </div>
        </div>
      </div>

      {/* Content */}
      <main>
        <Outlet />
        <Footer />
      </main>
    </div>
  );
};

export default Navbar;
